export const DATES = "dates"
export const EVENT = "event"
export const PERIOD = "period"
